/* eslint-disable react/no-unstable-nested-components */
import React, { FC, useCallback, useEffect, useRef, useState } from 'react';
import {
  LinkingOptions,
  NavigationContainer,
  NavigationContainerRef,
} from '@react-navigation/native';
import { useDispatch, useSelector } from 'react-redux';
import * as Keychain from '../services/keychain';
import { IS_WEB } from '../constants/platform';
import { RootState } from '../services/redux/store';
import { fcmUser, logoutUser, updateUser } from '../services/redux/user';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { RootStackParamList } from './types';
import { STYLE_VARS } from '../constants/style-vars';
import { post } from '../services/api/http';
import { API_URI } from '../constants/env';
import { Auth } from '../screens/Auth/Auth';
import NavHeader from './header';
import { AuthNavHeader } from './auth-header';
import { useIsDesktop } from '../hooks/useIsDeskTop';
import { NavigationService } from '../services/navigation';
import BottomTabs from './bottom-tabs';
import HeaderMobileLeft from './header-mobile-left';
import HeaderMobileRight from './header-mobile-right';
import { Alert, BackHandler, View } from 'react-native';
import { updateRoute } from '../services/redux/route';
import { EshopCategoryPage, EshopHomePage } from '../screens/EShop';
import EShopDetailPage from '../screens/EShop/EshopDetailPage';
import CheckoutPage from '../screens/EShop/CheckoutPage';
import {
  AccountStatement,
  MyPreferences,
  GrillRoom,
  PrivateFunction,
  DinningMenu,
  ServicesForms,
  Feedback,
  Survey,
  ReciprocalClubs,
  ApplyReciprocalClub,
  Notices,
  NoticeDetail,
  SportNews,
  ClubNews,
  DinningPromotion,
  ContactUs,
  ClubNewDetail,
  SportNewDetail,
} from '../screens';
import { DinningPromotionDetail } from '../screens/DinningPromotionDetail';
import EShopSubCategoryPage from '../screens/EShop/EshopSubCategoryPage/EshopSubCategoryPage';
import Dialog from '../components/Dialog';
import { AuthApi } from '../services/api/auth.api';
import { setHeaderConfigAxios } from '../services/api/axios';
import { logout, setUserInfo } from '../services/redux/reducers/AuthSlice';
import { wooCommerceApi } from '../services/api/wooCommerceApi';
import { setEShopCategories } from '../services/redux/reducers/EShopCategorySlice';
import IntroSlider from '../screens/IntroSlider/IntroSlider';
import ECardMember from '../components/ECardMember/ECardMember';
import { setIsShowStart } from '../services/redux/reducers/SwitchECardSlice';

const linking: LinkingOptions<RootStackParamList> = {
  prefixes: [API_URI],
  config: {
    screens: {
      Login: 'members-area/auth',
      Root: {
        path: 'members-area',
        screens: {
          HomeTab: 'home',
          MyAccountTab: 'my-account/profile',
          MyBookingsTab: 'my-account/bookings',
          MyOrdersTab: 'my-account/orders',
          MenuTab: {
            screens: {
              Menu: 'menu',
              Sports: {
                path: 'sports/:screen',
              },
              CourtDetail: {
                path: 'sports/Facility/:sheet/:court?',
              },
              EventList: {
                path: 'events/:screen',
              },
              EventDetail: 'events-detail/:id',
              Notices: 'notices/:screen',
              NoticeDetail: 'notices-detail/:id',
              EShopCheckout: 'checkout',
              EShopHomePage: 'e-shop/home',
              EShopCategoryPage: 'e-shop/categories/:name',
              EShopDetailPage: 'e-shop/item/:id',
              EShopSubCategoryPage: 'e-shop/categories/:categoryName/:name',
            },
          },
        },
      },
      GrillRoom: 'members-area/dinning/book-table',
      PrivateFunction: 'members-area/dinning/private-function',
      DinningPromotion: 'members-area/dinning/promotions',
      DinningPromotionDetail: 'members-area/dinning/promotions/:id',
      DinningMenu: 'members-area/dinning/menu',
      AccountStatememt: 'members-area/my-account/statement',
      MyPreferences: 'members-area/my-account/preferences',
      ServiceForm: 'members-area/club-services/services-forms',
      Feedback: 'members-area/club-services/feedback',
      Survey: 'members-area/club-services/survey',
      ReciprocalClubs: 'members-area/club-services/reciprocal-clubs',
      ApplyReciprocalClub: 'members-area/club-services/reciprocal-clubs/apply',
      ClubNews: 'members-area/news/clubs',
      ClubNewDetail: 'members-area/news/clubs/:id',
      SportNews: 'members-area/news/sports',
      SportNewDetail: 'members-area/news/sports/:id',
    },
  },
};

const Stack = createNativeStackNavigator<RootStackParamList>();

export const RootNavigator: FC = () => {
  // Init navigation services
  const navigationRef =
    useRef<NavigationContainerRef<RootStackParamList>>(null);
  NavigationService.initialize(navigationRef);
  //
  const dispatch = useDispatch();
  const { user } = useSelector((redux: RootState) => ({
    user: redux.user.data,
  }));
  const auth = useSelector((redux: RootState) => redux.authReducer);
  const { isShowStart } = useSelector(
    (redux: RootState) => redux.switchECardSlice
  );
  const [openEcard, setIsOpenEcard] = useState(false);
  const curRoute = useSelector((redux: RootState) => redux.route);
  const isDesktop = useIsDesktop();
  const initUser = useCallback(() => {
    if (auth.loggedin === true) {
      setHeaderConfigAxios(auth.token);
      AuthApi.getProfile()
        .then((res) => {
          dispatch(setUserInfo(res.data));
        })
        .catch((error) => {
          dispatch(logout());
          dispatch(setIsShowStart(false));
          if (!IS_WEB) {
            NavigationService.push('IntroSlider');
          }
        });
    }
    // Keychain.getInternetCredentials('kcc')
    //   .then((credentials) => {
    //     if (!credentials) {
    //       throw new Error();
    //     }

    //     let data = JSON.parse(credentials.password);
    //     dispatch(updateUser(data));

    //     if (data.loggedin) {
    //       if (!IS_WEB) {
    //         dispatch(fcmUser(data.email_wp));
    //       }
    //     }
    //   })
    //   .catch(async () => {
    //     if (user.token) {
    //       await post(API_URI + '/wp-json/echo/v1/logout');
    //     }
    //     dispatch(logoutUser());
    //   });
  }, [
    // dispatch,
    // user.token,
    auth.token,
    auth.loggedin,
    dispatch,
  ]);

  const getCategories = useCallback(async () => {
    try {
      const res = await wooCommerceApi.get('products/categories', {
        per_page: 20,
        parent: 0,
      });
      dispatch(setEShopCategories(res.data));
    } catch (error: any) {
      console.log(error);
    }
  }, [dispatch]);

  useEffect(() => {
    initUser();
    getCategories();

    if (auth.loggedin == true && isShowStart) {
      setIsOpenEcard(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initUser, getCategories]);
  useEffect(() => {
    // Custom BackHandler listener
    const handleBackPress = () => {
      if (
        curRoute.name === 'Root' &&
        (curRoute.params === undefined ||
          curRoute.params?.params?.screen === 'Menu' ||
          curRoute.params?.screen === 'MyAccountTab')
      ) {
        if (NavigationService.canGoBack()) {
          NavigationService.goBack();
        } else {
          Alert.alert('Exit', 'You want to exit app?', [
            {
              text: 'Cancel',
              onPress: () => {},
            },
            {
              text: 'Ok',
              onPress: () => {
                BackHandler.exitApp();
              },
            },
          ]);
        }
        return true;
      } else {
        NavigationService.pop();
        return true;
      }
    };
    BackHandler.addEventListener('hardwareBackPress', handleBackPress);
    // Remove listener
    return () => {
      BackHandler.removeEventListener('hardwareBackPress', handleBackPress);
    };
  }, [curRoute]);

  return (
    <NavigationContainer
      linking={linking}
      ref={navigationRef}
      onStateChange={(state) => {
        const data = {
          name: state ? state.routes[state.routes.length - 1].name : '',
          params: state
            ? state.routes[state.routes.length - 1].params || undefined
            : undefined,
        };
        dispatch(updateRoute({ name: data.name, params: data.params }));
      }}
    >
      <View style={{ flex: 1 }}>
        {isDesktop() && <NavHeader />}
        <Stack.Navigator
          screenOptions={{
            contentStyle: {
              backgroundColor: 'white',
              flex: 1,
            },
            headerShown: !isDesktop(),
          }}
          initialRouteName={
            !auth.loggedin ? (!IS_WEB ? 'IntroSlider' : 'Root') : 'Root'
          }
        >
          {!auth.loggedin ? (
            <Stack.Screen
              name="Login"
              component={Auth}
              options={{
                header: isDesktop()
                  ? (props) => <AuthNavHeader {...props} />
                  : undefined,
                headerStyle: { backgroundColor: STYLE_VARS.primaryColor },
                headerTitle: '',
                headerLeft: HeaderMobileLeft,
                headerRight: HeaderMobileRight,
              }}
            />
          ) : (
            <>
              <Stack.Screen
                name="AccountStatememt"
                component={AccountStatement}
                options={{
                  headerStyle: { backgroundColor: STYLE_VARS.primaryColor },
                  headerTitle: '',
                  headerLeft: HeaderMobileLeft,
                  headerRight: HeaderMobileRight,
                }}
              />
              <Stack.Screen
                name="MyPreferences"
                component={MyPreferences}
                options={{
                  headerStyle: { backgroundColor: STYLE_VARS.primaryColor },
                  headerTitle: '',
                  headerLeft: HeaderMobileLeft,
                  headerRight: HeaderMobileRight,
                }}
              />
              <Stack.Screen
                name="GrillRoom"
                component={GrillRoom}
                options={{
                  headerStyle: { backgroundColor: STYLE_VARS.primaryColor },
                  headerTitle: '',
                  headerLeft: HeaderMobileLeft,
                  headerRight: HeaderMobileRight,
                }}
              />
              <Stack.Screen
                name="PrivateFunction"
                component={PrivateFunction}
                options={{
                  headerStyle: { backgroundColor: STYLE_VARS.primaryColor },
                  headerTitle: '',
                  headerLeft: HeaderMobileLeft,
                  headerRight: HeaderMobileRight,
                }}
              />
              <Stack.Screen
                name="DinningMenu"
                component={DinningMenu}
                options={{
                  headerStyle: { backgroundColor: STYLE_VARS.primaryColor },
                  headerTitle: '',
                  headerLeft: HeaderMobileLeft,
                  headerRight: HeaderMobileRight,
                }}
              />
              <Stack.Screen
                name="ServiceForm"
                component={ServicesForms}
                options={{
                  headerStyle: { backgroundColor: STYLE_VARS.primaryColor },
                  headerTitle: '',
                  headerLeft: HeaderMobileLeft,
                  headerRight: HeaderMobileRight,
                }}
              />
              <Stack.Screen
                name="Feedback"
                component={Feedback}
                options={{
                  headerStyle: { backgroundColor: STYLE_VARS.primaryColor },
                  headerTitle: '',
                  headerLeft: HeaderMobileLeft,
                  headerRight: HeaderMobileRight,
                }}
              />
              <Stack.Screen
                name="Survey"
                component={Survey}
                options={{
                  headerStyle: { backgroundColor: STYLE_VARS.primaryColor },
                  headerTitle: '',
                  headerLeft: HeaderMobileLeft,
                  headerRight: HeaderMobileRight,
                }}
              />
              <Stack.Screen
                name="EShopHomePage"
                component={EshopHomePage}
                options={{
                  headerStyle: { backgroundColor: STYLE_VARS.primaryColor },
                  headerTitle: '',
                  headerLeft: HeaderMobileLeft,
                  headerRight: HeaderMobileRight,
                }}
              />
              <Stack.Screen
                name="ReciprocalClubs"
                component={ReciprocalClubs}
                options={{
                  headerStyle: { backgroundColor: STYLE_VARS.primaryColor },
                  headerTitle: '',
                  headerLeft: HeaderMobileLeft,
                  headerRight: HeaderMobileRight,
                }}
              />
              <Stack.Screen
                name="EShopCategoryPage"
                component={EshopCategoryPage}
                options={{
                  headerStyle: { backgroundColor: STYLE_VARS.primaryColor },
                  headerTitle: '',
                  headerLeft: HeaderMobileLeft,
                  headerRight: HeaderMobileRight,
                }}
              />
              <Stack.Screen
                name="EShopSubCategoryPage"
                component={EShopSubCategoryPage}
                options={{
                  headerStyle: { backgroundColor: STYLE_VARS.primaryColor },
                  headerTitle: '',
                  headerLeft: HeaderMobileLeft,
                  headerRight: HeaderMobileRight,
                }}
              />
              <Stack.Screen
                name="ApplyReciprocalClub"
                component={ApplyReciprocalClub}
                options={{
                  headerStyle: { backgroundColor: STYLE_VARS.primaryColor },
                  headerTitle: '',
                  headerLeft: HeaderMobileLeft,
                  headerRight: HeaderMobileRight,
                }}
              />
              <Stack.Screen
                name="EShopDetailPage"
                component={EShopDetailPage}
                options={{
                  headerStyle: { backgroundColor: STYLE_VARS.primaryColor },
                  headerTitle: '',
                  headerLeft: HeaderMobileLeft,
                  headerRight: HeaderMobileRight,
                }}
              />
              <Stack.Screen
                name="ClubNews"
                component={ClubNews}
                options={{
                  headerStyle: { backgroundColor: STYLE_VARS.primaryColor },
                  headerTitle: '',
                  headerLeft: HeaderMobileLeft,
                  headerRight: HeaderMobileRight,
                }}
              />
              <Stack.Screen
                name="ClubNewDetail"
                component={ClubNewDetail}
                options={{
                  headerStyle: { backgroundColor: STYLE_VARS.primaryColor },
                  headerTitle: '',
                  headerLeft: HeaderMobileLeft,
                  headerRight: HeaderMobileRight,
                }}
              />
              <Stack.Screen
                name="SportNews"
                component={SportNews}
                options={{
                  headerStyle: { backgroundColor: STYLE_VARS.primaryColor },
                  headerTitle: '',
                  headerLeft: HeaderMobileLeft,
                  headerRight: HeaderMobileRight,
                }}
              />
              <Stack.Screen
                name="SportNewDetail"
                component={SportNewDetail}
                options={{
                  headerStyle: { backgroundColor: STYLE_VARS.primaryColor },
                  headerTitle: '',
                  headerLeft: HeaderMobileLeft,
                  headerRight: HeaderMobileRight,
                }}
              />
              <Stack.Screen
                name="EShopCheckout"
                component={CheckoutPage}
                options={{
                  headerStyle: { backgroundColor: STYLE_VARS.primaryColor },
                  headerTitle: '',
                  headerLeft: HeaderMobileLeft,
                  headerRight: HeaderMobileRight,
                }}
              />
              <Stack.Screen
                name="ContactUs"
                component={ContactUs}
                options={{
                  headerStyle: { backgroundColor: STYLE_VARS.primaryColor },
                  headerTitle: '',
                  headerLeft: HeaderMobileLeft,
                  headerRight: HeaderMobileRight,
                }}
              />
            </>
          )}
          {!IS_WEB && !auth.loggedin && (
            <>
              {/* Disable on website */}
              {/* <Stack.Screen
                name="IntroSlider"
                component={IntroSlider}
                options={{
                  headerShown: false,
                }}
              /> */}
            </>
          )}
          <Stack.Group navigationKey={auth.loggedin ? 'member' : 'guest'}>
            <Stack.Screen
              name="Root"
              component={BottomTabs}
              options={{
                contentStyle: { flex: 1, backgroundColor: 'white' },
                headerStyle: { backgroundColor: STYLE_VARS.primaryColor },
                headerTitle: '',
                headerLeft: HeaderMobileLeft,
                headerRight: HeaderMobileRight,
              }}
            />
            <Stack.Screen
              name="DinningPromotion"
              component={DinningPromotion}
              options={{
                headerStyle: { backgroundColor: STYLE_VARS.primaryColor },
                headerTitle: '',
                headerLeft: HeaderMobileLeft,
                headerRight: HeaderMobileRight,
              }}
            />
            <Stack.Screen
              name="DinningPromotionDetail"
              component={DinningPromotionDetail}
              options={{
                headerStyle: { backgroundColor: STYLE_VARS.primaryColor },
                headerTitle: '',
                headerLeft: HeaderMobileLeft,
                headerRight: HeaderMobileRight,
              }}
            />
            <Stack.Screen
              name="Notices"
              component={Notices}
              options={{
                headerStyle: { backgroundColor: STYLE_VARS.primaryColor },
                headerTitle: '',
                headerLeft: HeaderMobileLeft,
                headerRight: HeaderMobileRight,
              }}
            />
            <Stack.Screen
              name="NoticeDetail"
              component={NoticeDetail}
              options={{
                headerStyle: { backgroundColor: STYLE_VARS.primaryColor },
                headerTitle: '',
                headerLeft: HeaderMobileLeft,
                headerRight: HeaderMobileRight,
              }}
            />
          </Stack.Group>
        </Stack.Navigator>
      </View>
      <ECardMember openModal={openEcard} setOpenModal={setIsOpenEcard} />
    </NavigationContainer>
  );
};
